import { DeepPartial } from '@empathybroker/ebx-gluon';
import { DevicesDetectionConfig } from '@empathybroker/ebx-gluon/dist/models';

export const DEVICE_CONFIG: DeepPartial<DevicesDetectionConfig> = {
  screenWidth: {
    mobile: 900
  }
};
